// Google AdSense configuration.
// Publisher ID is loaded via the script tag in index.html.
// After creating each ad unit in AdSense (Ads → By ad unit → Create new ad unit),
// paste the numeric data-ad-slot value below.
//
// Recommended unit TYPES when creating in AdSense:
//   ARTICLES_IN_FEED  → "In-feed ads"   (layout matched to article card)
//   DEALS_IN_FEED     → "In-feed ads"   (layout matched to deal/product card)
//   ARTICLE_IN_ARTICLE→ "In-article ads"
//   ARTICLE_NATIVE    → "Display ads" with format=fluid (sidebar/end-of-content)
//
// Until a slot is filled, the component renders nothing (no broken/empty boxes).

export const ADSENSE_CLIENT = "ca-pub-3471139923855549";

export const AD_SLOTS = {
  ARTICLES_IN_FEED: "2622024985",
  DEALS_IN_FEED: "9921930507",
  ARTICLE_IN_ARTICLE: "8013952464",
  ARTICLE_NATIVE: "4701393416",
} as const;

// Matched in-feed layout keys from AdSense.
export const AD_LAYOUT_KEYS = {
  ARTICLES_IN_FEED: "-6i+ce+2u-x+6c",
  DEALS_IN_FEED: "-6u+cp+5h-f-7g",
} as const;
